import http from "../js/axios";
import { addAuthParams } from "../js/common";
class ReportSerive {
  recharge() {
    let params = addAuthParams({});
    return http.get("/Admin/Services/Recharge.asmx/Recharge_History", {
      params,
    });
  }
  orders() {
    let params = addAuthParams({});
    params.getFromdate = "";
    params.getTodate = "";
    return http.get("/Admin/Services/Shopping.asmx/Order_List", {
      params,
    });
  }
  getSubjects() {
    return http.get("/Admin/Services/Recharge.asmx/Complain_Subject");
  }
}
export default new ReportSerive();
